const CHART_TYPES = {
  BAR: 'bar',
  LINE: 'line'
}

export { CHART_TYPES }
